import BaseEntity from '../base/BaseEntity.model';
import Persona from '../persona/persona.model';

export default class Beneficiario extends BaseEntity {
    public personaId?: number;
    public persona?: Persona;
    public cedula?: string;
    public hogarId?: number;
    public codigoHogar?: string;
    constructor() {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.cedula = undefined;
        this.personaId = undefined;
        this.codigoHogar = undefined;
        this.persona = undefined;
    }
}

export class CiudadanoEvaluado{
    public cedula?: string;
}